import { Textarea } from '@/components/common/Textarea';

interface GenericMetadataPartial {
  type?: string;
  generalNotes?: string;
}

interface GenericFormProps {
  metadata: GenericMetadataPartial;
  onChange: (updated: GenericMetadataPartial) => void;
}

export function GenericForm({ metadata, onChange }: GenericFormProps) {
  return (
    <div className="flex flex-col gap-4">
      <Textarea
        id="generic-notes"
        label="Notes"
        value={metadata.generalNotes ?? ''}
        onChange={(v) => onChange({ ...metadata, generalNotes: v || undefined })}
        placeholder="Add notes about this location..."
        rows={4}
      />
    </div>
  );
}
